import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';

import { QualificationService, SeedingEntry, formatLapTime } from '../service/qualification.service';

/**
 * Public qualification ("Shootout") table for a season: rank, fastest lap and
 * initial rating. Renders nothing once the season has real race results — from
 * then on the regular Ligatabelle is the standings.
 *
 * There is deliberately no *Abstand* column. It used to show
 * `best_lap_ms - entries[0].best_lap_ms`, which is meaningless as soon as the
 * shootout runs rounds on different circuits — it subtracted a lap set at one
 * track from a lap set at another. The rating is no longer derived from lap
 * times at all (it averages per-round finishing positions), so a gap in seconds
 * would not explain the order anyway. `entries[].results` carries the per-round
 * breakdown if this table ever wants to show it.
 */
@Component({
    selector: 'app-qualification-table',
    standalone: true,
    templateUrl: 'qualificationTable.component.html',
    imports: [CommonModule, RouterModule, TableModule],
    providers: [QualificationService],
})
export class QualificationTableComponent implements OnChanges {
    @Input() season!: number;
    @Input() seasonName: string | null = null;

    entries: SeedingEntry[] = [];
    visible = false;

    constructor(private qualiService: QualificationService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['season']) {
            this.visible = false;
            this.entries = [];
            if (!this.season) { return; }
            this.qualiService.getSeeding(this.season).subscribe({
                next: (res) => {
                    this.entries = res.entries;
                    this.visible = !res.has_race_results && res.entries.length > 0;
                },
                error: () => (this.visible = false),
            });
        }
    }

    lapTime(entry: SeedingEntry): string {
        return formatLapTime(entry.best_lap_ms);
    }
}
